import React, { useEffect, useRef } from "react";
import "./WhyKlean.scss";
import { Container, Row, Col } from "react-bootstrap";
import { Card } from "antd";
import { Image } from "react-bootstrap";

import trusted from "../../Assets/why/trusted.webp";
import support from "../../Assets/why/support.webp";
import transparency from "../../Assets/why/transparency.webp";
import samples from "../../Assets/why/samples.webp";
import moq from "../../Assets/why/moq.webp";
import consultation from "../../Assets/why/consultation.webp";


const WhyKlean = () => {

    const upgradeImageRef = useRef(null);
    const cardRefs = useRef([]);

    useEffect(() => {
        const handleScrollAnimation = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
            entry.target.classList.add("animate");
            observer.unobserve(entry.target);
            }
        });
        };

        const observer = new IntersectionObserver(handleScrollAnimation, {
        threshold: 0.1,
        });

        const upgradeImage = upgradeImageRef.current;
        const cards = [...cardRefs.current];

        if (upgradeImage) {
        observer.observe(upgradeImage);
        }

        cards.forEach((card) => {
        if (card) {
            observer.observe(card);
        }
        });

        return () => {
        if (upgradeImage) {
            observer.unobserve(upgradeImage);
        }
        cards.forEach((card) => {
            if (card) {
            observer.unobserve(card);
            }
        });
        };
  }, []);


  return (
    <Container fluid className="home-why white">
        <Container className="inner-container left">
            <Row className="justify-content-center features-title pb-4">
                <h2>Why Choose Klean Leaf as Your Laundry Sheet Supplier?</h2>
            </Row>

            <Row className="left d-flex align-items-stretch">
                <Col md={4} className="equal-height-cards">
                <Card className="slide-up" ref={(el) => (cardRefs.current[0] = el)}>
                    <h4>Private Label Expertise</h4>
                    <div className="flex left">
                        <Image className="feature-icon" src={trusted} alt="Private label laundry sheet supplier support" loading="lazy" />
                        <p>
                        Support for brands, wholesalers, refill shops, retailers, and e-commerce companies launching laundry sheets.

                        </p>
                    </div>
                </Card>
                </Col>

                <Col md={4} className="equal-height-cards">
                <Card className="slide-up" ref={(el) => (cardRefs.current[1] = el)}>
                    <h4>Custom Formula and Scent Options</h4>
                    <div className="flex left">
                        <Image className="feature-icon" src={support} alt="Custom laundry sheet formula support" loading="lazy" />
                        <p>
                        Choose fragrance-free, review scent samples, or develop a custom direction for your market positioning.
                        </p>
                    </div>
                </Card>
                </Col>

                <Col md={4} className="equal-height-cards">
                <Card className="slide-up" ref={(el) => (cardRefs.current[2] = el)}>
                    <h4>Certifications and Transparency</h4>
                    <div className="flex left">
                        <Image className="feature-icon" src={transparency} alt="Laundry detergent sheet documentation and certifications" loading="lazy" />
                        <p>
                        Available documents include ISO 9001, ISO 22716 GMP, OECD 301B, MSDS, and optional third-party testing support.
                        </p>
                    </div>
                </Card>
                </Col>

                <Col md={4} className="equal-height-cards">
                <Card className="slide-up" ref={(el) => (cardRefs.current[3] = el)}>
                    <h4>Sample and Packaging Support</h4>
                    <div className="flex left">
                        <Image className="feature-icon" src={samples} alt="Laundry detergent sheet sample support from Columbus Ohio" loading="lazy" />
                        <p>
                        Sample support from Columbus, Ohio helps your team compare sheet performance, scent, and packaging.
                        </p>
                    </div>
                </Card>
                </Col>

                <Col md={4} className="equal-height-cards">
                <Card className="slide-up" ref={(el) => (cardRefs.current[4] = el)}>
                    <h4>Flexible Packaging Formats</h4>
                    <div className="flex left">
                        <Image className="feature-icon" src={moq} alt="Private label laundry sheet packaging options" loading="lazy" />
                        <p>
                        Paper bags, paper boxes, custom packaging, perforated sheet formats, and bulk refill cartons are available.
                        </p>
                    </div>
                </Card>
                </Col>

                <Col md={4} className="equal-height-cards">
                <Card className="slide-up" ref={(el) => (cardRefs.current[5] = el)}>
                    <h4>Export and Logistics Experience</h4>
                    <div className="flex left">
                        <Image className="feature-icon" src={consultation} alt="Laundry sheet logistics and delivery support" loading="lazy" />
                        <p>
                        End-to-end support can cover manufacturing, packaging, customs, freight, and delivery coordination.
                        </p>
                    </div>
                </Card>
                </Col>
            </Row>
        </Container>
  </Container>
        
        
  );
};

export default WhyKlean;
